import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
    apiKey: "AIzaSyByS1W47UHuNh9vKCRMIzLV2RcAYbgE580",
    authDomain: "tele-sa.firebaseapp.com",
    projectId: "tele-sa",
    storageBucket: "tele-sa.firebasestorage.app",
    messagingSenderId: "632823962599",
    appId: "1:632823962599:web:f493a17af5eb4b0b49bb42",
    measurementId: "G-XW2E4WRVHC"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Export Firebase Authentication
export const auth = getAuth(app);